export default (templateData) => {
  const requestData = {
    name: templateData?.bankName,
    country: templateData?.bankCountry,
    bic: templateData?.bic
  };

  // Add paymentPurpose as 'purpose' for UAE
  if (templateData?.bankCountry === 'AE' && templateData?.paymentPurpose) {
    requestData.paymentPurpose = templateData.paymentPurpose;
  }

  return requestData;
};
